import { createCustomEnum } from "./customEnum";

const TicketQaResults = createCustomEnum({
	qa_approved: {
		name: "qa_approved",
		value: 0,
		displayName: "QA Approved",
	},
	qa_rejected: {
		name: "qa_rejected",
		value: 1,
		displayName: "QA Rejected",
	},
});

export default TicketQaResults;
